import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'CHILD_PROFILE/LEAVE_WIDGET';

export const {
    action: fetch,
    success: fetchSuccess,
    failed: fetchFailed,
} = createAction(
    `${domain}/FETCH`,
    (personId, personType) => ({personId, personType}),
    (leave, bradfordFactor, vacation, timezone) => {
        return {
            leave,
            bradfordFactor,
            vacation,
            timezone,
        };
    },
);

export const {
    action: deleteChildLeave,
    success: deleteChildLeaveSuccess,
    failed: deleteChildLeaveFailed,
} = createAction(
    `${domain}/DELETE_CHILD_LEAVE`,
    (childId, startDate, endDate) => ({childId, startDate, endDate}),
    (startDate, endDate) => ({startDate, endDate}),
    startDate => ({startDate}),
);

export const {action: changeYear} = createAction(`${domain}/CHANGE_YEAR`, year => ({year}));

export const {action: reset} = createAction(`${domain}/RESET`);
